import { render, staticRenderFns } from "./UpgradeOption.vue?vue&type=template&id=3b8ee83e&scoped=true&"
import script from "./UpgradeOption.vue?vue&type=script&lang=js&"
export * from "./UpgradeOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ee83e",
  null
  
)

export default component.exports